import Svg from 'components/utilities/svg'

const PanIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Pan Icon</title>
    <path d="M11.7 24q-.875 0-1.575-.312-.7-.313-1.275-.888L1 14.825l1.3-1.25q.275-.25.688-.275.412-.025.712.15L8 15.9V4q0-.6.45-1.05.45-.45 1.05-.45.6 0 1.05.45Q11 3.4 11 4v7h1V1.5q0-.6.45-1.05Q12.9 0 13.5 0q.6 0 1.05.45Q15 .9 15 1.5V11h1V2.5q0-.6.45-1.05Q16.9 1 17.5 1q.6 0 1.05.45.45.45.45 1.05V11h1V5.5q0-.6.45-1.05Q20.9 4 21.5 4q.6 0 1.05.45.45.45.45 1.05V20q0 1.65-1.175 2.825Q20.65 24 19 24Z" />
  </Svg>
)

PanIcon.displayName = 'Pan'

export default PanIcon
